module.exports = __webpack_public_path__ + "9488cf4fae75b89e08ba5a69b7bae709.png";